import { Block } from 'ui-kit/blocks'
import { Heading, Text } from 'ui-kit/typography'
import { Certification } from 'routes/components/Features/Certification'
import { VendorLock } from 'routes/components/Features/VendorLock'
import classes from './SolutionInfrastructure.module.scss'

export const SolutionInfrastructure = () => {
  return (
    <Block
      as={'section'}
      pad={'baseMob'}
      divider={'mobile'}
      className={classes.section}
    >
      <div className={classes.heading}>
        <Heading as={'h2'} size={'xl'} balance center className={classes.title}>
          Run on your infrastructure or in the cloud
        </Heading>
        <Text size={'lg'} balance center className={classes.subtitle}>
          Integrations are a key component of your product. You can't afford
          them to be disconnected.
        </Text>
      </div>
      <Certification className={classes.certification} />
      <VendorLock className={classes.vendor} />
    </Block>
  )
}
